import moment from "moment";
import ApiClient from "../api/apiClient";

const USERCPDACTIVTIES = "/user-cpd-activities";
const MANAUALCPDACTIVTIES = "/user-cpd-activities/manual-cpd";
const ALLACTIVITIES = "/user-cpd-activities/cpds";
const UPDATEACTIVITYSTATUS = "/user-cpd-activities";
const ACTIVITYDETAILSSTATUS = "/cpds";
const ADDUSERCPDACTIVITY = "/user-cpd-activities";
const SUGGESTEDCPDACTIVITY = "/cpds/suggested";
const SEARCHCPDTITLE = "/cpds/search-cpd";
const USERCPDOVERVIEW = "/user-cpd-activities/get-user-cpd-activity";
const UPDATECPDACTIVITY = "/user-cpd-activities/";
const DELETEDCPDACTIVITY = "/user-cpd-activities";
const SAVEDCPDACTIVITY = "/user-cpd-activities/optional-cpd";
const GETCPDACTIVITYHOURS = "cpds/get-cpd-hours";

const getUserCpdActivities = ({ page, limit, start_date, end_date, type_of_cpd, status, search }) => {
    const baseUrl = `${USERCPDACTIVTIES}?`;
    let queryParams = "";
    queryParams += `page=${page}&limit=${limit}`;
    // Add optional parameters if present
    if (start_date !== null) queryParams += `&start_date=${start_date}`;
    if (end_date !== null) queryParams += `&end_date=${end_date}`;
    if (type_of_cpd) queryParams += `&type_of_cpd=${type_of_cpd}`;
    if (status) queryParams += `&status=${status}`;
    if (search) queryParams += `&search=${search}`;
    const url = baseUrl + queryParams;
    return ApiClient.get(url);
};
const getUserCpdActivitiesOverview = ({ start_date, end_date }) => {
    const startDate = moment(start_date).format('YYYY-MM-DD')
    const endDate = moment(end_date).format('YYYY-MM-DD')
    const baseUrl = `${USERCPDOVERVIEW}?`;
    const queryParams = `start_date=${startDate}&end_date=${endDate}`;
    const url = baseUrl + queryParams;

    return ApiClient.get(url);
};

const manualCpdActivities = (data) => {
    return ApiClient.post(MANAUALCPDACTIVTIES, data);
};

const getAllActivities = ({ query, sort, page,limit }) => {
    const baseUrl = `${ALLACTIVITIES}?`;
    let queryParams = "";

    // Add optional parameters if present
    if (query !== undefined && query !== null && query !== "") queryParams += `&query=${query}`;
    if (sort !== undefined && sort !== null && sort !== "") queryParams += `&sort=${sort}`;
    if (page !== undefined) queryParams += `&page=${page}`;
    if (limit !== undefined) queryParams += `&limit=${limit}`;

    const url = baseUrl + queryParams;
    return ApiClient.get(url);
};

const updateActivityStatus = (id) => {
    const url = UPDATEACTIVITYSTATUS + "/" + id;
    return ApiClient.patch(url);
};

const activityDetailById = (id) => {
    const url = ACTIVITYDETAILSSTATUS + "/" + id;
    return ApiClient.get(url);
};

const addUserCpdActivity = (data) => {
    return ApiClient.post(ADDUSERCPDACTIVITY, data);
};

const getSuggestedCpdActivities = () => {
    return ApiClient.get(SUGGESTEDCPDACTIVITY);
};

const getCPDTitle = (search) => {
    const baseUrl = `${SEARCHCPDTITLE}?`;
    let queryParams = "";
    if (search !== undefined) queryParams += `&search=${search}`;
    const url = baseUrl + queryParams;
    return ApiClient.get(url);
};

const updateCPDActivity = (id, data) => {
    const url = UPDATECPDACTIVITY + id;
    return ApiClient.put(url, data);
};

const deleteCPDActivity = (id) => {
    const url = `${DELETEDCPDACTIVITY}/${id}`;
    return ApiClient.delete(url);
};

const saveCpdActivity = (data) => {
    return ApiClient.post(SAVEDCPDACTIVITY, data);
}

const getCPDActivityHours = (user_id) => {
    const url = `${GETCPDACTIVITYHOURS}?user_id=${user_id}`;
    return ApiClient.get(url);
};

export const cpdActivitiesService = {
    getUserCpdActivities,
    manualCpdActivities,
    getAllActivities,
    updateActivityStatus,
    activityDetailById,
    addUserCpdActivity,
    getSuggestedCpdActivities,
    getCPDTitle,
    getUserCpdActivitiesOverview,
    updateCPDActivity,
    deleteCPDActivity,
    saveCpdActivity,
    getCPDActivityHours
};
